import React, {Component} from 'react';
import {Redirect} from "react-router";
import {withTranslation} from 'react-i18next';
import ClientLoanList from "./Dashboard/ClientLoanList";

class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        if (!this.props.is_logged_in) {
            return (<Redirect push={true} to='/auth/login'/>);
        }

        return (
            <div>

                <header className="text-white bg-primary-dark heading-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="heading-block__header">{this.props.t('loans')}</h1>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="section window-layout">
                    {!_.isEmpty(this.props.user) ? <ClientLoanList {...this.props}/> : null}
                </div>

            </div>
        )
    }
}

export default withTranslation()(Dashboard);
